import getFetchResponse, { ApiResponse } from '../../get-fetch-response'

export type SmsPhoneNumberPayload = ApiResponse & {
  success: boolean
  message: string | null
  code: number | null
}

// https://petstore.swagger.io/?url=https://staging-api.thriveglobal.com/v2/swagger.json#/sms/post_phone_number
export const postPhoneNumber = async (
  companyHint: string,
  // phone number must be in e.164 format. the endpoint will 400 when invalid.
  phoneNumber: string
) => {
  const body = { companyHint, phoneNumber }
  const res = await getFetchResponse<SmsPhoneNumberPayload>(
    { method: 'POST', path: '/v2/sms/post_phone_number', body },
    true
  )
  return res
}
